import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  title: "",
  description:
    "In this section we will check whether the measured resonance frequency of a wine bottle matches its theoretical prediction.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          options: {},
          items: [
            {
              name: "Bottle dimensions",
            },
            {
              name: "Resonance frequency",
            },
            {
              name: "Bottle sound",
            },
            {
              name: "Spectrum",
            },
            {
              name: "Length corrections",
            },
          ],
        },
      ],
      extraContent: [[], [], [], [], []],
      components: [
        {
          variant: "blockContainer",
          data: {
            block: {
              type: "image",
              options: {
                src: `${config.ASSETS_URL}/04/04/principle/bottle-dimensions.svg`,
              },
            },
          },
        },
        {
          variant: "blockContainer",
          data: {
            block: {
              type: "image",
              options: {
                src: `${config.ASSETS_URL}/04/04/principle/resonance-frequency.svg`,
              },
            },
          },
        },
        {
          variant: "layout",
          data: {
            type: "table",
            options: {
              cols: 2,
              rows: 2,
              rowSpan: {
                "0:0": 2,
              },
              components: [
                [
                  {
                    variant: "blockContainer",
                    data: {
                      block: {
                        type: "image",
                        options: {
                          src: `${config.ASSETS_URL}/04/04/principle/bottle.svg`,
                          viewType: "fill",
                          styles: {
                            padding: "15%",
                          },
                        },
                      },
                    },
                  },
                  {
                    variant: "blockContainer",
                    data: {
                      block: {
                        type: "text",
                        options: {
                          data:
                            "When the neck of the bottle</br>is blown, a sound is created</br>with <b>a low-frequency tone.</b>",
                          scrollbars: false,
                        },
                      },
                      styles: {
                        alignItems: "flex-end",
                        justifyContent: "flex-start",
                      },
                    },
                  },
                ],
                [
                  null,
                  {
                    variant: "blockContainer",
                    data: {
                      block: {
                        type: "audioButton",
                        options: {
                          text: "listen",
                          shape: "round",
                          icon: "cil-volume-high",
                          size: "xlarge",
                          url: `${config.ASSETS_URL}/04/04/principle/bottle-sound.mp3`,
                        },
                      },
                      styles: {
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                      },
                    },
                  },
                ],
              ],
            },
          },
        },
        {
          variant: "blockContainer",
          data: {
            block: {
              type: "image",
              options: {
                src: `${config.ASSETS_URL}/04/04/principle/spectrum.svg`,
              },
            },
          },
        },
        {
          variant: "layout",
          data: {
            type: "table",
            options: {
              cols: 2,
              rows: 1,
              colsSize: [0.75, 1.25],
              components: [
                [
                  {
                    variant: "blockContainer",
                    data: {
                      block: {
                        type: "image",
                        options: {
                          src: `${config.ASSETS_URL}/04/04/principle/bottle.svg`,
                          viewType: "fill",
                          styles: {
                            padding: "15%",
                          },
                        },
                      },
                    },
                  },
                  {
                    variant: "blockContainer",
                    data: {
                      block: {
                        type: "text",
                        options: {
                          data: `
                            Length corrections take into account sudden changes in cross-section at the ends of the neck.
                            <br />
                            <br />
                            Outside: <span style="color: #FF6040; font-weight: 700">0.61 × the inner neck radius r<sup>e</sup><sub>n</sub></span>
                            <br />
                            <br />
                            Inside: no closed-form solution, an approximate calculation gives <span style="color: #FF6040; font-weight: 700;">0.27 × inner neck radius r<sup>i</sup><sub>n</sub></span>
                            <br />
                            <br />
                            Total length: l<sub>n</sub> + <span style="color: #FF6040; font-weight: 700;">0.61r<sup>e</sup><sub>n</sub></span> + <span style="color: #FF6040; font-weight: 700;">0.27r<sup>i</sup><sub>n</sub></span><br />= 8.8 cm instead of 7.5 cm
                            <br />
                            <br />
                            By taking into account the length corrections, we get a theoretical value of f<sub>r</sub> equal to 114 Hz which is closer to the measured value: 116 Hz
                          `,
                          scrollbars: false,
                          styles: {
                            fontWeight: 400,
                            fontSize: "16px",
                            lineHeight: "24px",
                          },
                        },
                      },
                    },
                  },
                ],
              ],
            },
          },
        },
      ],
    },
  },
};

export default principle;
